/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import EditAdmin from "./features/subadminfield";

const AddSubAdmin = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <EditAdmin />
        </section>
      </Layout>
    </>
  );
};
export default AddSubAdmin;
